import { IonIcon } from '@ionic/react';
import { checkmarkOutline } from 'ionicons/icons';
import React from 'react';

export type ModuloPlano = {
  id: string;
  titulo: string;
  valorFormatado: string;
  recomendado?: boolean;
  recursos?: string[];
};

export function obterModulosContratados(modulos: ModuloPlano[], contratados?: Record<string, boolean>): string[] {
  return modulos.filter(modulo => contratados?.[modulo.id] === true).map(modulo => modulo.id);
}

type Props = {
  modulo: ModuloPlano;
  selecionado: boolean;
  ativo: boolean;
  onToggle: () => void;
};

export default function ModuloPlanoCard({ modulo, selecionado, ativo, onToggle }: Props) {
  return (
    <section className={`pagamentos-card pagamentos-modulo ${selecionado ? 'is-selected' : ''}`}>
      <div className="pagamentos-card-heading">
        <div className="pagamentos-selecao">
          <span className="pagamentos-checkbox" aria-hidden="true">
            {selecionado && <IonIcon icon={checkmarkOutline} />}
          </span>
          <h3>{modulo.titulo}</h3>
        </div>
        <div className="pagamentos-modulo-selos">
          {ativo && <span className="pagamentos-badge pagamentos-badge-ativo">Ativo no seu plano</span>}
          {modulo.recomendado && <span className="pagamentos-badge">Recomendado</span>}
        </div>
      </div>
      <p className="pagamentos-preco">+ {modulo.valorFormatado}<span> /mês</span></p>
      <ul className="pagamentos-recursos">
        {modulo.recursos?.map((recurso, i) => <li key={i}><IonIcon icon={checkmarkOutline} aria-hidden="true" /><span>{recurso}</span></li>)}
      </ul>
      <button type="button" role="checkbox" aria-checked={selecionado} aria-label={modulo.titulo} className="pagamentos-modulo-acao" onClick={onToggle}>
        {selecionado ? 'Remover' : '+ Adicionar ao plano'}
      </button>
    </section>
  );
}
